import { Alert, Button, Container } from '@mui/material';
import { useAuth } from '@/providers';
import { useUrl } from '@/utils/client/route';

export default function Alerts() {
  const { loginUrl, registerUrl } = useUrl();
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) return null;

  return (
    <Container
      sx={(theme) => ({
        p: 0,
        m: 0,
        [theme.breakpoints.up('sm')]: {
          px: 2,
          mx: 'auto',
        },
      })}>
      <Alert
        severity="info"
        icon={false}
        action={
          <>
            <Button
              color="info"
              size="small"
              variant="contained"
              target="_blank"
              href={registerUrl}
              sx={{ mr: '8px' }}>
              Registrieren
            </Button>
            <Button
              color="info"
              size="small"
              target="_blank"
              variant="outlined"
              href={loginUrl}
              sx={{ mr: 1 }}>
              Anmelden
            </Button>
          </>
        }>
        Für alle Features:
      </Alert>
    </Container>
  );
}
